import React from 'react'
import style from './Item.module.css'

const Item = ({ 
  product, 
  code,
  location, 
  producedQuantity,
  stockQuantity,
  exportedQuantity,
  expirationDate,
  expeditionDate,
  id,
  onClickOption
}) => {
  return (
    <React.Fragment>
      <div>{product}</div>
      <div>{code}</div>
      <div>{location}</div>
      <div>{producedQuantity}</div>
      <div>{stockQuantity}</div>
      <div>{exportedQuantity}</div>
      <div>{expeditionDate}</div>
      <div>{expirationDate}</div>
      <div className={`${style.delete_button} animate__animated animate__fadeIn`} onClick={onClickOption}>Eliminar</div>


    </React.Fragment>
  )
}

export default Item